export function hydrateOcr(data, params ) {
    const isDefine = (key) => { return undefined !== data[key] && data[key].value !== 'N/A' };
        const findIdTva = (rate) => {
            return params.tvaList.find(tva => parseFloat(tva.rate) === parseFloat(rate))?.id;
        };
    const getAccountCode = () => { return params.accountingCodes.find(code => code.id === params.defaultAccountingCode) }
    const isPurchaseCode = () => { return !!getAccountCode() };
    const getAccountingCodeLabel = () => { return getAccountCode()?.label || '' };

    let ocr = {
        supplier: !_.isNil(data.supplier) && !_.isNil(data.supplier.id) ? +data.supplier.id : null,
        documentDate: isDefine('invoice_date') && !_.isEmpty(data.invoice_date.value) ? data.invoice_date.value + ' 00:00:00' : '',
        currency: isDefine('locale') ? data.locale.value : '',
        totalWithoutTax: isDefine('total_excl') ? data.total_excl.value : null,
        totalWithTax: isDefine('total_incl') ? data.total_incl.value : null,
        externalDocumentName: isDefine('invoice_number') ? data.invoice_number.value : null,
    };

    if (isDefine('due_date') && !_.isEmpty(data.due_date.value)) {
        ocr.dueDate = data.due_date.value + ' 00:00:00';
    } else if (isDefine('invoice_date') && !_.isEmpty(data.invoice_date.value)) {
        ocr.dueDate = data.invoice_date.value + ' 00:00:00';
    } else {
        ocr.dueDate = '';
    }

    if(isDefine('taxes')) {
        ocr.products = [];
        if (!data.taxes.length) {
            ocr.products.push({
                description: getAccountingCodeLabel(),
                accountingCode: isPurchaseCode() ? params.defaultAccountingCode : null,
                tva: null,
                priceTva: null,
                priceWithoutTax: ocr.totalWithoutTax,
                priceWithTax: ocr.totalWithTax,
            })
        }

        if (data.taxes.length === 1) {
            let taxe = data.taxes[0];

            //if we have one card, set product amounts with total amounts
            let productDetails = {
                description: getAccountingCodeLabel(),
                accountingCode: isPurchaseCode() ? params.defaultAccountingCode : null,
                tva: findIdTva(taxe.rate) || null,
                priceTva: taxe.value || null,
                priceWithoutTax: ocr.totalWithoutTax,
                priceWithTax: ocr.totalWithTax,
            };

            ocr.products.push(productDetails);
        } else {
            data.taxes.forEach(taxe => {

                let productDetails = {
                    description: getAccountingCodeLabel(),
                    accountingCode: isPurchaseCode() ? params.defaultAccountingCode : null,
                    tva: findIdTva(taxe.rate) || null,
                    priceTva: taxe.value || null,
                    priceWithoutTax: null,
                    priceWithTax: null,
                };

                ocr.products.push(productDetails);

            });
        }
    }
    return ocr;
}
